module.exports = __webpack_public_path__ + "static/img/chart_2.1dbc0fa9.svg";